import { configureStore } from "@reduxjs/toolkit";
import BCSOrderSlice from "../Features/BCSOrder/BCSOrderSlice";
import coveredCallOrder from "../Features/CoveredCallOrder/coveredCallOrderSlice";
import ReplacementCoveredCallSlice from "../Features/ReplacementCoveredCall/ReplacementCoveredCallSlice";
import replacementBCSSlice from "../Features/ReplacementBCS/replacementBCSSlice";
import stepSlice from "../Features/Step/stepSlice";
import sahraUserGroupsSlice from "../Features/SahraUserGroups/sahraUserGroupsSlice";
import manualSlice from "../Features/Manual/manualSlice";
import uPairSlice from "../Features/UPair/uPairSlice";
import optionGreekSlice from "../Features/OptionGreek/optionGreekSlice";
import sahraConnectionsSlice from "../Features/SahraConnections/SahraConnectionsSlice";
import deltaHedgeSettingsSlice from "../Features/DeltaHedgeSettings/deltaHedgeSettingsSlice";
import deltaHedgeAccountsSlice from "../Features/DeltaHedgeAccounts/deltaHedgeAccountsSlice";
import optionDomainSlice from "../Features/OptionDomain/optionDomainSlice";
import nLegsSlice from "../Features/NLegs/nLegsSlice";
import marketmakingSlice from "../Features/Marketmaking/marketmakingSlice";
import deltaHedgeMarketmakingSlice from "../Features/DeltaHedgeMarketmaking/deltaHedgeMarketmakingSlice";
import FundNoRiskSlice from "src/Features/FundNoRisk/fundNoRiskSlice";
import deltaHedgeOrderSlice from "../Features/DeltaHedgeOrder/deltaHedgeOrderSlice";
import deltaHedgeExePhase3Slice from "../Features/DeltaHedgeExePhase3/deltaHedgeExePhase3Slice";
import automaticMarketMakingSlice from "../Features/AutomaticMarketMaking/automaticMarketMakingSlice";
import ccOrder from "../Features/CCOrder/ccOrderSlice";
import coveredCall from "../Features/CoveredCall/CoveredCallSlice";
export const store = configureStore({
  reducer: {
    BCSOrder: BCSOrderSlice,
    coveredOrder: coveredCallOrder,
    replacementCoveredCall: ReplacementCoveredCallSlice,
    replacementBCS: replacementBCSSlice,
    step: stepSlice,
    sahraUserGroup: sahraUserGroupsSlice,
    manual: manualSlice,
    uPair: uPairSlice,
    optionGreek: optionGreekSlice,
    sahraConnections: sahraConnectionsSlice,
    deltaHedgeSettingsSlice,
    deltaHedgeAccountsSlice,
    optionDomain: optionDomainSlice,
    nLegs: nLegsSlice,
    marketmaking: marketmakingSlice,
    deltaHedgeMarketmaking: deltaHedgeMarketmakingSlice,
    fundNoRisk: FundNoRiskSlice,
    deltaHedgeOrder: deltaHedgeOrderSlice,
    deltaHedgeExePhase3Slice,
    automaticMarketMaking: automaticMarketMakingSlice,
    ccOrder,
    coveredCall,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
